export const createProjectPayload = vm => ({
    title: vm.form.title,
    description: vm.form.description,
    status: vm.form.status?.toLowerCase(),
    startDate: vm.form.startDate,
    deadline: vm.form.deadline,
    priority: vm.form.priority,
    projectType: vm.form.projectType?.toLowerCase() || "not paid",
    billingType: vm.form.billingType || "flat",
    estimatedRevenue: vm.form.estimatedRevenue,
    isFavourite: vm.form.isFavourite === "no" ? false : true,
    currency: vm.form.currency,
    billableHours: Number(vm.form.billableHours || ""),
    reminders: vm.form.reminders,
    trackProject: vm.form.trackProject === "Yes" ? true : false,
    trackingDays: vm.form.trackingDays,
    trackingType: vm.form.trackingType,
    links: [],
});